import {
  SUREST_FILTER_DATA_REQUEST,
  SUREST_FILTER_DATA_SUCCESS,
  SUREST_FILTER_DATA_FAILURE,
  SUREST_FILTER_DATA_LOADING,
  SUREST_RELATIVE_GRAPH_DATA_REQUEST,
  SUREST_RELATIVE_GRAPH_DATA_SUCCESS,
  SUREST_RELATIVE_GRAPH_DATA_FAILURE,
  SUREST_RELATIVE_GRAPH_DATA_LOADING,
  SUREST_RESET
} from '@src/middleware/actions/actionTypes';

export const getSurestFilterDataRequest = (payload: any) => ({
  type: SUREST_FILTER_DATA_REQUEST,
  payload
});

export const getSurestFilterDataSuccess = (data: any) => ({
  type: SUREST_FILTER_DATA_SUCCESS,
  payload: data
});

export const getSurestFilterDataError = (error: any) => ({
  type: SUREST_FILTER_DATA_FAILURE,
  payload: { error }
});

export const setSurestFilterLoading = (isLoading: boolean) => ({
  type: SUREST_FILTER_DATA_LOADING,
  payload: { isLoading }
});

export const getSurestRelativeGraphRequest = (payload: any) => ({
  type: SUREST_RELATIVE_GRAPH_DATA_REQUEST,
  payload
});

export const getSurestRelativeGraphSuccess = (data: any) => ({
  type: SUREST_RELATIVE_GRAPH_DATA_SUCCESS,
  payload: data
});

export const getSurestRelativeGraphError = (error: any) => ({
  type: SUREST_RELATIVE_GRAPH_DATA_FAILURE,
  payload: { error }
});

export const setSurestRelativeGraphLoading = (isLoading: boolean) => ({
  type: SUREST_RELATIVE_GRAPH_DATA_LOADING,
  payload: { isLoading }
});

export const resetSurest = () => ({
  type: SUREST_RESET
});